import {AxiosInstance} from "axios";
import API from "../../utils/api";
import {PaginatedResult} from "../../models/core/paginated.result";
import {DeclarationsProvider} from "../../models/declarations/declarations.providers";
import {PaginatedRequest} from "../../models/core/paginated.request";

export class DeclarationsProvidersService {
    api: AxiosInstance = API;

    getAll(request: PaginatedRequest): Promise<PaginatedResult<DeclarationsProvider>> {
        return this.api.get<PaginatedResult<DeclarationsProvider>>(
            'declarations/providers',
            {
                params: request.toParams()
            }
        ).then(x => x.data);
    }

    create(data: any): Promise<DeclarationsProvider> {
        return this.api.post<DeclarationsProvider>('declarations/providers', data).then(x => x.data);
    }

    update(id: number, data: any): Promise<DeclarationsProvider> {
        return this.api.post<DeclarationsProvider>('declarations/providers/' + id, data).then(x => x.data);
    }

    remove(id: number): Promise<any> {
        return this.api.delete<any>('declarations/providers/' + id).then(x => x.data);
    }
}

export const declarationsProvidersService = new DeclarationsProvidersService();
